// formats a US number as "+1 555-123-4567"; anything else is not displayed
export const parsePhoneNumber = (phoneNumber: string) => {
  if (
    !phoneNumber ||
    typeof phoneNumber !== 'string' ||
    phoneNumber?.length < 10
  ) {
    return null
  }
  const cleaned = ('' + phoneNumber).replace(/\D/g, '')
  if (phoneNumber.length === 12 && phoneNumber.startsWith('+1')) {
    return `+1 ${cleaned.slice(1, 4)}-${cleaned.slice(4, 7)}-${cleaned.slice(
      7
    )}`
  } else if (cleaned.length === 10 && !phoneNumber.startsWith('+')) {
    return `+1 ${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(
      6
    )}`
  }
  return null
}
